import { render } from "./configuraciones.vue?vue&type=template&id=218e3635&scoped=true"
import script from "./configuraciones.vue?vue&type=script&lang=js"
export * from "./configuraciones.vue?vue&type=script&lang=js"

import "./configuraciones.vue?vue&type=style&index=0&id=218e3635&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218e3635"]])

export default __exports__